export default {
  $: 'Text',
  children: ({ number }) =>
    number && !Number.isNaN(number)
      ? new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 1,
          maximumFractionDigits: 4,
          minimumSignificantDigits: 1,
          maximumSignificantDigits: 4,
        }).format(number)
      : '',
};
